





































































import { Component, Prop, Vue } from "vue-property-decorator";
import StockTable from "./stockTable.vue";
import { handleRetain } from "../../../../../common/untils/formData";

const win: any = window;
@Component({
  components: {
    StockTable
  },
  filters: {
    changeFilter(value: any) {
      if (value > 0) {
        return "+" + handleRetain(value, 2) + "%";
      } else if (value < 0) {
        return handleRetain(value, 2) + "%";
      } else if (value == 0) {
        return value + "%";
      } else {
        return "--";
      }
    },
    numFilter(value: any) {
      if(!value && String(value) === '0') {
        return '0'
      }
      if(!value) {
        return '--'
      }
      return value
    }
  }
})
export default class BlockCell extends Vue {
  @Prop({ default: 1 }) private readonly top?: number | string;
  @Prop({ default: "--" }) private readonly limit_up_num?: number | string;
  @Prop({ default: "--" }) private readonly continuous_plate_num?:
    | number
    | string;
  @Prop({ default: "--" }) private readonly change?: number | string;
  @Prop({ default: "--" }) private readonly name?: number | string;
  @Prop({ default: "--" }) private readonly code?: number | string;
  @Prop({ default: "--" }) private readonly hight?: number | string;
  @Prop({ default: "--" }) private readonly days?: number | string;
  @Prop() private readonly list?: any;

  private maidian = "free_ztjj.zqfk";

  get topName() {
    if (this.top && this.top < 4) {
      return "No." + this.top + " " + this.name;
    } else {
      return this.name;
    }
  }
  get topNum() {
    return "top-" + this.top;
  }

  private jumpBlock(stockcode: string) {
    win.F10Utils.fenshiJump({ stockcode: stockcode });

    // alert("jump block");
  }
}
